<!--
  實例:
  <hk-radio v-model="value" label="1">Individual</hk-radio>
-->
<template>
  <div class="hk-container">
    <div class="hk-radio" :style="label == 'COMPANY'?'width:2.2rem':(label == 'SOLE'||label == 'JOINT')?'width:2.2rem':''">
      <span>
        <input @click="click" @keydown="keydown" type="radio" :id="groupName+index+label" class="radio-label" :class="value == label && value != '' ? 'active': ''" :checked="formValue == label ? 'checked': ''" tabindex="0" :title="title" :name="groupName+index" :aria-describedby="ariaDescribedby"/>
        <label :for="groupName+index+label">
          <slot></slot>
        </label>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    groupName: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    ariaDescribedby: {
      type: String,
      default: ''
    },
    checked: {
      type: String,
      default: 'false'
    },
    formValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectVal: '',
      isChecked: false
    }
  },
  methods: {
    click () {
      console.log(`this.label`,this.label)
      console.log(`this.value`,this.value)
      if(this.label != this.value){
        this.selectVal = this.label;
        this.$emit('input', this.selectVal)
        this.$emit('change', this.selectVal)


      }

      if(this.value == '1') {
        this.$emit('input', '')
        this.$emit('change', '')
      }
      this.$forceUpdate();
    },
    keydown (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        this.click()
      }
      this.$forceUpdate();
    }
  },
  mounted () {
    this.selectVal = this.value;
    console.log(`this.value`,this.value)
    console.log(`this.label`,this.label)
    if(this.value == this.label){
      this.isChecked = true;
      this.$emit('input', this.label)
      this.$emit('change', this.label)
    }
    this.$forceUpdate();
  }
}
</script>

<style lang="scss" scoped>
// 樣式是HkRadio.scss, 在all.scss中引入
</style>



// WEBPACK FOOTER //
// src/components/HkRadio.vue